var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 110,
    viewBox: "0 0 1920 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 110
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-471.729 -889.476)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.428 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.343 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.829 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.6 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(802.113 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1114.627 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1427.141 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.086 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(645.856 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(958.37 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1270.884 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1583.397 -112.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58V5024.5h26.257v-7.241",
    transform: "translate(12272 -3949.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12298 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12324 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12350 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12376 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11630.843,4986.58v7.507h26.257v-7.507",
    transform: "translate(12402 -3918.593)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(482.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(796.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(950.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1108.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1266.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1420.271 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1576.527 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1733.284 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1889.041 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15:00:00")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(638.729 992.5)",
    fill: "#b1b1b1",
    fontSize: 12,
    fontFamily: "'QueenofCamelot2\\\\\\\\.0', 'Queen of Camelot \\\\\\\\32 \\\\\\\\.0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23:00:00")), /*#__PURE__*/React.createElement("path", {
    d: "M-11649.5,4928.395s19.767,15.137,37.689,14.912,43.571-57.686,69.538-58.585,31.272,17.22,40.238,17.22,13.6-25.31,23.543-23.909,24.4,47.853,55.354,50.363,58.276-38.955,86.124-22.838,37.477,36.046,73.689,16.732,35.882-55.234,71.273-32.786,21.9,47.017,69.332,42.53,59.354-17.077,88.2-16.63,29.893,15.359,69.323,12.992,45.043,2.133,77.044,3.638,100.159,16.187,120.5,15.556,21.76,1.992,21.76,1.992H-11649.5Z",
    transform: "translate(12155.729 -3986.5)",
    opacity: 0.239,
    fill: "url(#a)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTimeline);
export default __webpack_public_path__ + "static/media/home_timeline.f90df1aa914838752a417f8981317bb2.svg";
export { ForwardRef as ReactComponent };